import { useMemo } from 'react'

import { UrlStateStorageKeys } from 'modules/url-state-storage/consts'
import {
  UseHashedSearchParams,
  useHashedSearchParams,
} from 'modules/url-state-storage/useHashedSearchParams'
import { GlobalFilterState } from 'pages/Monitoring/GlobalFilters/GlobalFilters'
import { getDefaultTimeRangeParams } from 'utils/time/getDefaultTimeRangeParams'
import { isTimeStringValid } from 'utils/time/isTimeStringValid'

// BE requires to always provide start and end together,
// but we don't want to make user to always select both
export const prepareShiftStartParams = (
  start: string | undefined,
  end: string | undefined,
) => {
  if (start && end) {
    return {
      start,
      end,
    }
  }

  if (start) {
    if (!isTimeStringValid(start)) {
      return {}
    }

    return {
      start,
      end: end || '23:59',
    }
  }

  if (end) {
    if (!isTimeStringValid(end)) {
      return {}
    }

    return {
      start: start || '00:00',
      end,
    }
  }

  return {}
}

export const useTimeRangeParams = ({
  contextKey,
}: UseHashedSearchParams<GlobalFilterState>) => {
  const { state } = useHashedSearchParams<GlobalFilterState>({
    hashParamKey: UrlStateStorageKeys.GlobalFilters,
    contextKey,
  })

  const defaultTimeParams = useMemo(() => getDefaultTimeRangeParams(), [])

  const from = Number(state.from) || defaultTimeParams.from
  const to = Number(state.to) || defaultTimeParams.to

  return {
    from,
    to,
    ...prepareShiftStartParams(state.start, state.end),
  }
}
